import { render } from "./ProjectManagerMix.vue?vue&type=template&id=00cfc54c&ts=true"
import script from "./ProjectManagerMix.vue?vue&type=script&lang=ts"
export * from "./ProjectManagerMix.vue?vue&type=script&lang=ts"

import "./ProjectManagerMix.vue?vue&type=style&index=0&id=00cfc54c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__